import { Action } from "../types/competitionfilter";
import { PlayerMarkets, marketDataType } from "../types/marketFilter";
import { statsDataType } from "../types/statsFilter";
import { presetDataType } from "../types/presetData";
import { BookmakerDataType } from "../types/bookmaker";
import { Event } from "../types/fixture";

interface initStateTypes {
  configData: {
    basedOn: statsDataType[];
    bookmakers: BookmakerDataType[];
    competitions: string[];
    markets: marketDataType[];
    playerMarkets: PlayerMarkets;
    orderBy: statsDataType[];
    presetFilters: presetDataType[];
  };
  competitions: string[];
  date: string;
  games: string[];
  market: string;
  gamesFilter: string;
  statsFilter: string;
  selectedFilter: string;
  fixtures: Event[];
  events: Event[];
  chartLoading: boolean;
  isLicensed: boolean;
}

const initState: initStateTypes = {
  configData: {
    basedOn: [],
    bookmakers: [],
    competitions: [],
    markets: [],
    playerMarkets: { NBA: [], NFL: [], MLB: [], NHL: [] },
    orderBy: [],
    presetFilters: [],
  },
  competitions: [] as string[],
  date: "",
  games: [],
  market: "",
  gamesFilter: "stats-desc",
  statsFilter: "",
  selectedFilter: "",
  fixtures: [],
  events: [],
  chartLoading: false,
  isLicensed: false,
};

const filter = (state = initState, action: Action) => {
  let competitionAlreadyPresent;

  if (action.type === "ADD_COMPETITION_TO_SEARCH") {
    competitionAlreadyPresent = state.competitions.some(
      (competition) => competition === action.payload
    );
  }

  switch (action.type) {
    case "ADD_COMPETITION_TO_SEARCH":
      if (!competitionAlreadyPresent) {
        return {
          ...state,
          competitions: [action.payload],
        };
      }
      return state;
    case "REMOVE_COMPETITION_FROM_SEARCH":
      return {
        ...state,
        selectedFilter: '',
        competitions: [],
        date: "3days",
        games: [],
        market: "ML",
        statsFilter: 'season',
        gamesFilter: "stats-desc",
      };

    case "SET_FLASHPICKS_CONFIG_DATA":
      return Object.assign({}, state, {
        configData: action.payload,
      });

    case "SET_DATE_FILTER":
      return Object.assign({}, state, {
        date: action.payload,
      });

    case "SET_GAMES": // this is point to games filter (Smart Picks UI v2)
      return Object.assign({}, state, {
        games: action.payload,
      });

    case "SET_GAMES_FILTER": // this is point to form filter (legacy)
      return Object.assign({}, state, {
        gamesFilter: action.payload,
      });

    case "SET_MARKET_FILTER":
      return Object.assign({}, state, {
        market: action.payload,
      });
    case "SET_STATS_FILTER":
      return Object.assign({}, state, {
        statsFilter: action.payload,
      });
    case "SET_SELECTED_FILTER":
      return Object.assign({}, state, {
        selectedFilter: action.payload,
      });
    case "SET_FIXTURES":
      return Object.assign({}, state, {
        fixtures: action.payload,
      });
    case "SET_EVENTS":
      return Object.assign({}, state, {
        events: action.payload,
      });
    case "SET_CHART_LOADING":
      return Object.assign({}, state, {
        chartLoading: action.payload,
      });
    case "SET_IS_LICENSED":
      return Object.assign({}, state, {
        isLicensed: action.payload,
      });
    default:
      return state;
  }
};

export default filter;
